<template>
  <div class="fixed inset-0 z-1000">
    <CockpitDialog
      title="添加疏散路径"
      left="580px"
      width="990px"
      height="650px"
      top="120px"
      @close="visible = false"
    >
      <div class="h-full flex flex-col">
        <div class="flex-auto h-0 overflow-hidden">
          <div class="flex mb-20px mr-10px">
            <el-input
              size="small"
              class="mr-10px !w-50 "
              placeholder="请输入路径名称、编码"
              v-model="searchData.keyword"
              clearable
            ></el-input>
            <el-select
              popper-class="visualization-select-popper"
              size="small"
              class="mr-10px !w-50"
              filterable
              placeholder="请选择区域"
              v-model="searchData.areaId"
              clearable
            >
              <el-option
                v-for="item in areaList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
            <button
              class="handle_btn search mr-10px"
              size="small"
              type="button"
              @click="handleSearch"
            >
              搜索
            </button>
            <button class="handle_btn" size="small" type="button" @click="resetText">
              重置
            </button>
          </div>
          <el-table
            ref="table"
            :data="tableData"
            class="w-full"
            :height="tableHeight"
            v-loading="loading"
            @selection-change="handleSelection"
            :row-key="(row) => row.id"
          >
            <el-table-column
              :reserve-selection="multiple"
              type="selection"
              width="50"
              v-if="multiple"
              :selectable="isDisabled"
            ></el-table-column>
            <el-table-column label="序号" type="index" width="50"></el-table-column>
            <el-table-column
              label="路径编码"
              prop="code"
              min-width="200"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              label="疏散路径名称"
              prop="name"
              min-width="120"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              label="所属区域"
              prop="areaName"
              min-width="120"
              show-overflow-tooltip
            ></el-table-column>
          </el-table>
          <el-pagination
            background
            @size-change="baseTableSizeChange"
            @current-change="baseTableCurrentChange"
            :current-page.sync="basePageConfig.SkipCount"
            :page-size.sync="basePageConfig.MaxResultCount"
            layout="total, sizes, prev, pager, next, jumper"
            :page-sizes="[15, 30, 45, 60, 75, 90]"
            :total="total"
            class="float-right mt-10px mb-10px ml-10px"
          ></el-pagination>
        </div>
        <div class="text-center py-10px flex justify-center" v-if="multiple">
          <button class="handle_btn mr-10px" @click="handleOk">
            <span>确定</span>
          </button>
          <button class="handle_btn" @click="visible = false">
            <span>取消</span>
          </button>
        </div>
      </div>
    </CockpitDialog>
  </div>
</template>

<script type="text/babel">
import { EvacuatePathApi } from '@wiz-api/emergency-management'
import { AreaApi } from '@wiz-api/area-management'
import CockpitDialog from '@/components/cockpit/CockpitDialog'

const areaApi = new AreaApi()
const evacuatePathApi = new EvacuatePathApi()

export default {
  name: 'evacuation-path-dialog',
  components: {
    CockpitDialog,
  },
  props: {
    // 是否多选
    multiple: {
      type: Boolean,
      default: true,
    },
    dataList: {
      default: [],
    },
  },
  data() {
    return {
      personList: '',

      visible: true,
      tableData: [],
      areaList: [],
      loading: false,
      total: 0,
      searchData: {},
      basePageConfig: {
        SkipCount: 1,
        MaxResultCount: 15,
      },
      selectionData: [],
    }
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 100px)'
    },
  },
  watch: {
    visible(val) {
      if (!val) {
        this.$emit('cancel')
      }
    },
  },
  created() {
    this.getAreaList()
    this.findList()
  },
  methods: {
    // 禁用复选框
    isDisabled(row) {
      const selection = this.dataList.map((item) => {
        return item.id
      })
      if (selection.includes(row.id)) {
        return 0
      }
      return 1
    },
    // 设置选中
    setSelect() {
      this.dataList.forEach((item) => {
        this.$refs.table.toggleRowSelection({ id: item.id })
      })
    },
    // 选中结果事件
    handleSelection(values) {
      this.selectionData = values
    },
    // 获取区域列表
    async getAreaList() {
      const [err, res] = await areaApi.getList({
        skipCount: 0,
        maxResultCount: 999,
      })
      if (!err) {
        this.areaList = res.items || []
      }
    },

    // 重置
    resetText() {
      this.searchData = this.$options.data().searchData
      this.handleSearch()
    },
    // 搜索 equip 设备设施 base 作业活动
    handleSearch() {
      this.basePageConfig.SkipCount = 1
      this.findList()
    },
    // 页码改变
    baseTableSizeChange(MaxResultCount) {
      this.basePageConfig.MaxResultCount = MaxResultCount
      this.findList()
    },
    // 页数改变
    baseTableCurrentChange(SkipCount) {
      this.basePageConfig.SkipCount = SkipCount
      this.findList()
    },
    // 作业活动列表
    async findList() {
      const data = {
        maxResultCount: this.basePageConfig.MaxResultCount, // 每页多少条
        skipCount: (this.basePageConfig.SkipCount - 1) * this.basePageConfig.MaxResultCount, // 跳过多少条
        ...this.searchData,
      }
      this.loading = true
      const [err, res] = await evacuatePathApi.pagedListQuery(data)
      if (!err) {
        this.tableData = res.items
        this.total = res.totalCount
      }
      this.loading = false
    },
    handleOk() {
      const data = this.selectionData.map((item) => {
        return {
          ...item,
          pathId: item.id,
          pathNo: item.code,
          pathName: item.name,
        }
      })
      this.$emit('handleOk', data)
      this.visible = false
    },
  },
}
</script>

<style scoped lang="scss">
.handle_btn {
  height: 32px;
  width: 96px;
  border-radius: 32px;
  background: linear-gradient(180deg, #137ee566 0%, #19a4da66 100%),
    linear-gradient(-180deg, #05bdff00 0%, #3bfff566 100%);
  box-shadow: inset 0px 1px 15px 0px #77c4ff33;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  cursor: pointer;
  &:hover {
    background: #4dc2d2;
  }
}
.search {
  background: #4dc2d2;
}
.handle_btn[disabled] {
  cursor: no-drop;
}
::v-deep .el-dialog__body {
  padding-bottom: 10px;
}
</style>
